module.exports = __webpack_public_path__ + "img/vertical-logo-pink.2b309b48.svg";